import { Result, Button } from 'antd'
import { useNavigate } from 'react-router-dom'

const ForbiddenPage = () => {
  const navigate = useNavigate()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="Non sei autorizzato ad accedere a questa pagina."
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            Torna alla Dashboard
          </Button>
        }
      />
    </div>
  )
}

export default ForbiddenPage
